import { Notyf } from "notyf";
import React from "react";

export default React.createContext(
  new Notyf({
    duration: 10000,
    position: {
      x: "center",
      y: "top"
    },
    types: [
      {
        type: "default",
        backgroundColor: "#3B7DDD",
        icon: {
          className: "notyf__icon--success",
          tagName: "i"
        },
        dismissible: true
      },
      {
        type: "success",
        backgroundColor: "#28a745",
        icon: {
          className: "notyf__icon--success",
          tagName: "i"
        },
        dismissible: true
      },
      {
        type: "warning",
        backgroundColor: "#ffc107",
        icon: {
          className: "notyf__icon--error",
          tagName: "i"
        },
        dismissible: true
      },
      {
        type: "danger",
        backgroundColor: "#dc3545",
        icon: {
          className: "notyf__icon--error",
          tagName: "i"
        },
        dismissible: true
      }
    ]
  })
);
